<template>
  <d-modal
    @close="handleClose"
    size="lg">
    <d-modal-header>
      <d-modal-title>
        {{ $t('customer.historyDiffPopup.title') }}
      </d-modal-title>
    </d-modal-header>

    <d-modal-body class="p-0">
      <d-alert
        v-if="!loaded && !loadError"
        show
        theme="light">
        {{ $t('ui.dataLoading') }}
      </d-alert>

      <d-alert
        v-if="loadError"
        show
        theme="danger">
        {{ $t('ui.errorOccuredDesc') }}
      </d-alert>

      <table
        v-if="loaded && !loadError"
        class="table">
        <thead>
          <tr>
            <th>{{ $t('customer.historyDiffPopup.fieldName') }}</th>
            <th>{{ $t('customer.historyDiffPopup.previousValue') }}</th>
            <th>{{ $t('customer.historyDiffPopup.currentValue') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(diffItem, index) of differences"
            :key="'diff-item-' + index">
            <td>
              {{ getFieldLabel(diffItem.field) }}
            </td>
            <td>
              {{ diffItem.before }}
            </td>
            <td>
              <template v-if="isListField(diffItem.field)">
                <div
                  v-for="(line, lineIndex) of splitList(diffItem.after)"
                  :key="'diff-item-' + index + '-line-' + lineIndex">
                  {{ line }}
                </div>
              </template>
              <template v-else>
                {{ diffItem.after }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-history-item-differences-popup',
  props: [
    'historyItemIdToLoad'
  ],
  data () {
    return {
      loaded: false,
      loadError: false,
      differences: []
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      FormUtils.loadItemData(this, {
        method: 'get',
        endpointBase: '/customers/editions/item/',
        instanceFields: ['differences'],
        loadedKey: 'loaded',
        errorKey: 'loadError',
        overrideID: parseInt(this.historyItemIdToLoad, 10)
      });
    },
    getFieldLabel (field) {
      let key = 'customer.historyDiffPopup.fields.' + field;

      return this.$te(key) ? this.$t(key) : field;
    },
    isListField (field) {
      return ['added', 'changed', 'removed'].includes(field);
    },
    splitList (value) {
      return String(value || '').split(';').map(line => line.trim()).filter(line => line.length);
    },
    handleClose () {
      this.$bus.$emit('customer-history-item-differences-close');
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
